import { Input } from '@builder.io/sdk';

import { buttonFields } from 'molecules/Button/config';

import { idField } from 'utils/builder/fields';

const noIconCardFields = [
  idField,
  { name: 'title', type: 'string', defaultValue: 'Default Title' },
  {
    name: 'description',
    type: 'richText',
    helperText: 'Optional body text shown between the title and the CTA.',
  },
  {
    name: 'button',
    type: 'object',
    subFields: buttonFields,
  },
] as const satisfies DeepReadonly<Input[]>;

export type NoIconCardConfigProps = GenerateBuilder<typeof noIconCardFields>;

export default noIconCardFields;
